import React from "react";

import { Flex, Heading, Spacer, Text } from "@kazoohr/confetti";
import { Trans, useTranslation } from "@kazoohr/internationalization";

export function ArchivedAccountPage() {
  const { t } = useTranslation();
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ paddingTop: "4rem", textAlign: "center" }}
    >
      <Heading level="1">{t("content:auth.accountArchived")}</Heading>
      <Spacer />
      <Text paragraph>{t("content:auth.noLongerHaveAccess")}</Text>
      <Spacer size="small" />
      <Text paragraph>
        <Trans
          i18nKey="content:auth.contactSupport"
          components={{
            supportLink: <a href="mailto:constellation@worktango.com" />,
          }}
        />
      </Text>
    </Flex>
  );
}
